import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import {
  SpanElement,
  type HeadingFiveElement,
} from '~/components/organism/PluginsEditor/types';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import serializeHeading from '../../../utils/serialize/serializeHeading';

export type Props = RenderElementProps & {
  element: SpanElement;
};

const HeadingFive: React.FCC<Props> = ({ attributes, element, children }) => (
  <Container {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.h5<{}>`
  margin: 0;
`;

export default {
  renderComponent: props => <HeadingFive {...props} />,
  nodeName: 'H5',
  deserialize: () => ({
    type: ELEMENTS.H5,
  }),
  serialize: (node: HeadingFiveElement, children) =>
    serializeHeading('h5', children),
};
